import { Country } from "../types/countries";
import { LANG, LANGUAGE } from "../types/lang";

export function getLangFromCountry(countryName?: string): string {
  const countryLangMap: Record<string, LANG> = {
    "FRA": LANG.FR,
    "BEL": LANG.FR,
    "ROU": LANG.EN,
    "ITA": LANG.EN,
  };

  return countryLangMap[countryName?.toUpperCase() as Country] || LANG.FR;
}

export const getLanguageLabel = (lang: string) => {
    switch (lang) {
      case LANG.EN : return LANGUAGE.EN;
      case LANG.NL : return LANGUAGE.NL;
      case LANG.FR :
      default: return LANGUAGE.FR;
    }
  };